/* eslint-disable vue/valid-v-slot */
<template>
  <div>
    <v-container v-if="yetki" fluid>
      <!-- Üst Bilgi Alanı -->
      <v-row>
        <!-- Sol Kart -->
        <v-col cols="12" :md="form.onaylama ? 4 : 12">
          <v-card class="pa-4" color="#1F7087" dark>

            <v-card-title class="headline">{{ form.name }}</v-card-title>
            <v-card-text>

              <div><strong>Form ID:</strong> {{ form?.formId }}</div>
              <div><strong>Oluşturan:</strong> {{ form?.olusturan }}</div>
              <div><strong>Başlamama Tarihi:</strong> {{ form?.baslamaTarihi }}</div>
              <div><strong>Bitiş Tarihi:</strong> {{ form?.bitisTarihi }}</div>
              <div><strong>Toplam Başvuru:</strong> {{ form.basvurular.length }}</div>

            </v-card-text>
          </v-card>
        </v-col>

        <!-- Sağ İstatistik Kartları -->
        <v-col cols="12" :md="form?.onaylama ? 8 : 12" v-if="form?.onaylama">
          <v-row>
            <v-col> <v-alert type="warning">
                <div>Bu form yöneticiler tarafından onaylama işlemine tabii
                  tutulacaktır.
                </div>
                <div>
                  Lütfen başvurunuzun durumunu aşağıdaki başvuru listesinizden takip ediniz
                </div>
              </v-alert></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3" v-for="(val, key) in stats" :key="key">
              <v-card class="pa-1" :color="cardColors[key]" outlined>
                <v-list-item three-line>
                  <v-list-item-avatar tile size="50"> <v-icon size="45" class="mb-2" :color="iconColors[key]">
                      {{ icons[key] }}
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="text-center">
                    <div class="subtitle-1 font-weight-bold text-h3">

                      {{ getDurumSayisiGetir(val.id) }}
                    </div>
                    <v-list-item-title class="text-h3 mb-1 headline">

                    </v-list-item-title>
                    <!-- <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle> -->
                  </v-list-item-content>


                </v-list-item>
                <v-card-actions class="font-weight-bold text-center d-print-block text-h6" style="display: block;">
                  {{ labels[key] }}
                </v-card-actions>
                <!-- <div class="text-center">
     
                <div class="subtitle-1 font-weight-bold">{{ labels[key] }}</div>
                <div class="">{{ val }}</div>
              </div> -->
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Alt Tablo ve Butonlar -->
      <v-card class="mt-6">
        <v-card-title>
          Başvurular
          <v-spacer></v-spacer>

          <!-- Durum Filtresi -->
          <v-select v-model="selectedStatus" :items="statusOptions" label="Duruma Göre Filtrele" item-text="named"
            v-if="form?.onaylama" item-value="id" clearable dense outlined style="max-width: 200px"
            class="mr-3"></v-select>

          <!-- Arama -->
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Ara" single-line hide-details dense
            outlined></v-text-field>

          <!-- Butonlar -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="editItem(item)" color="primary" dark class="ml-3" v-bind="attrs" v-on="on">
                <v-icon large class="mx-2">
                  mdi-database-arrow-left-outline
                </v-icon>Yeni Başvuru
              </v-btn>

            </template>
            <span>Form Veri Girişi</span>
          </v-tooltip>


        </v-card-title>

        <!-- Tablo -->
        <v-data-table :headers="headers" :items="filteredApplications" :search="search" class="elevation-1" dense
          :items-per-page="5" :footer-props="{ itemsPerPageOptions: [5, 10, 20, -1] }">
          <!--    <template v-slot=item.onayDurumId="{ item }">
          {{  item.onayDurumId}}
      <v-chip :color="statusColor(item.onayDurumId)" dark small>
            {{ item.status }}
          </v-chip>
        </template> -->
          <template v-slot:item.named="{ item }">

            <v-chip :color="statusColor(item.onayDurumId)" dark small>
              {{ item.named }}
            </v-chip>

          </template>
          <template v-slot:item.reddedilmeNedeni="{ item }">

            <span style="color:red">{{ item.reddedilmeNedeni }}</span>

          </template>

          <template v-if="form.onaylama" v-slot:item.actions="{ item }">



            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">

                <v-btn v-if="![3, 4].includes(item.onayDurumId)" color="primary"
                  @click="btnFormSavedDuzenle(item.formSavedId)" v-bind="attrs" v-on="on">
                  <v-icon>mdi-table-edit</v-icon>Düzenle
                </v-btn>

              </template>
              <span>Form Güncelle</span>
            </v-tooltip>









          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <UnAuthorized v-else></UnAuthorized>
  </div>

</template>

<script>
import FormService from '@/services/FormService';
import OnayDurumService from '@/services/OnayDurumService';
import OnayDurumEnum from '@/plugins/Enum'
import router from '@/router';
import UnAuthorized from '../UnAuthorized.vue'

export default {
  components: { UnAuthorized },
  data() {
    return {
      yetki: true,
      search: "",
      selectedStatus: null,
      form: {
        baslamaTarihi: "12.08.2025",
        bitiTarihi: "27.08.2025",
        olusturan: "Form Test",
        sadeceBirDefaBasvur: false,
        onaylama: true,
        name: "Birim Faaliyetleri",
        basvurular: [
          {
            "createDate": "19 Ağustos 2025 Salı 09:02:29",
            "onayDurumId": 1,
            "named": "Onaya Sunuldu",
            "reddedilmeNedeni": ""
          },

        ]
      },
      stats: {
        // approved: 20,
        // pending: 10,
        // rejected: 5,
        // revision: 7,
        approved: { name: "ONAYLAYAN", id: 3 },
        pending: { name: "ONAY BEKLEYEN", id: 1 },
        rejected: { name: "REDDEDİLEN", id: 4 },
        revision: { name: "DÜZELTME BEKLEYEN", id: 5 },
      },
      labels: {
        approved: "ONAYLAYAN",
        pending: "ONAY BEKLEYEN",
        rejected: "REDDEDİLEN",
        revision: "DÜZELTME BEKLEYEN",
      },
      cardColors: {
        approved: "green lighten-4",
        pending: "blue lighten-4",
        rejected: "red lighten-4",
        revision: "orange lighten-4",
      },
      icons: {
        approved: "mdi-check-circle",
        pending: "mdi-clock-outline",
        rejected: "mdi-close-circle",
        revision: "mdi-pencil-circle",
      },
      iconColors: {
        approved: "green darken-2",
        pending: "blue darken-2",
        rejected: "red darken-2",
        revision: "orange darken-2",
      },
      headers: [
        { text: "Başvuru Tarihi", value: "createDate" },
        { text: "Onay Durumu", value: "named" },

        { text: "Red Nedeni", value: "reddedilmeNedeni" },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      applications: [
        // { name: "Ali Veli", date: "2025-08-01", status: "Onaylanan" },
        // { name: "Ayşe Demir", date: "2025-08-03", status: "Onay Bekleyen" },
        // { name: "Mehmet Kaya", date: "2025-08-05", status: "Reddedilen" },
        // { name: "Zeynep Yılmaz", date: "2025-08-08", status: "Düzeltme Bekleyen" },
        // { name: "Burak Can", date: "2025-08-10", status: "Onaylanan" },
      ],
      statusOptions: [],
    };
  },

  created() {
    this.dataBind();

  },
  computed: {
    filteredApplications() {
      if (!this.selectedStatus) return this.form.basvurular;
      return this.form.basvurular.filter(app => app.onayDurumId === this.selectedStatus);
    },
  },
  methods: {
    editItem(v) {
      console.log("editItem", this.form);
      router.push({ name: 'formgosterim', params: { id: this.form.formId } })
    },
    getDurumSayisiGetir(tur) {
      //console.log("getDurumSayisiGetir", this.form.basvurular?.filter(m => m.onayDurumId == tur).length);
      return this.form.basvurular?.filter(m => m.onayDurumId == tur).length ?? 0;
    },
    btnFormSavedDuzenle(guid) {

      router.push({ name: 'formgosterimedit', params: { id: guid } })
      console.log("dfsdf", guid);
    },
    dataBind() {
      // console.log("Enum",OnayDurumEnum.DuzeltmeliReddet);
      OnayDurumService.listOnayDurumsed().then((result) => {
        this.statusOptions = result.data;
      }).catch((err) => {

      });
      FormService.KullaniciFormBilgisi(this.$route.params.id).then((result) => {
        console.log("KullaniciFormBilgisi", result);
        this.form = result.data;
        if (!this.form.onaylama) {
          this.headers = this.headers.splice(0, 1);

        }
      }).catch((err) => {
        if (err.status === 405) {
          this.yetki = false;
        }
      });
    },
    statusColor(status) {
      console.log("Status", status);
      switch (status) {
        case OnayDurumEnum.Onaylandi: return "green";
        case OnayDurumEnum.OnaySunuldu: return "blue";
        case OnayDurumEnum.Reddet: return "red";
        case OnayDurumEnum.DuzeltmeliReddet: return "orange";
        default: return "grey";
      }
    },
  },
};
</script>
